module.exports = {
	contact: 'rgb(160, 148, 237)',
	workOrder: 'rgb(80, 227, 194)',
	post: 'rgb(101, 202, 228)',
	carousel: 'rgb(107, 189, 110)',
	resourceSkill: 'rgb(69, 193, 115)',
	goals: 'rgb(86, 170, 223)',
	investmentAccount: 'rgb(75, 192, 118)',
	default: 'rgb(129, 153, 175)',
	caseMilestone: 'rgb(242, 207, 91)',
	today: 'rgb(239, 126, 173)',
	leadList: 'rgb(248, 137, 98)',
	productItemTransaction: 'rgb(248, 137, 98)',
	answerPrivate: 'rgb(242, 207, 91)',
	retailBankingConsole: 'rgb(0, 175, 160)',
	channelProgramMembers: 'rgb(14, 181, 138)',
	appsAdmin: 'rgb(152, 149, 238)',
	datadotcom: 'rgb(21, 137, 238)',
	productItem: 'rgb(118, 158, 217)',
	metrics: 'rgb(86, 170, 223)',
	topic2: 'rgb(86, 170, 208)',
	partnerFundAllocation: 'rgb(14, 181, 138)',
	approval: 'rgb(80, 204, 122)',
	iotOrchestrations: 'rgb(42, 115, 158)',
	personAccount: 'rgb(127, 141, 225)',
	entity: 'rgb(248, 137, 98)',
	serviceTerritoryLocation: 'rgb(126, 139, 228)',
	readReceipts: 'rgb(75, 192, 118)',
	maintenanceAsset: 'rgb(42, 115, 158)',
	marketingActions: 'rgb(107, 189, 110)',
	caseTranscript: 'rgb(242, 207, 91)',
	timesheetEntry: 'rgb(125, 195, 125)',
	task: 'rgb(75, 192, 118)',
	answerBest: 'rgb(242, 207, 91)',
	orders: 'rgb(118, 158, 217)',
	pastChat: 'rgb(248, 137, 96)',
	feedback: 'rgb(109, 161, 234)',
	actionListComponent: 'rgb(88, 118, 163)',
	opportunitySplits: 'rgb(252, 185, 91)',
	messagingUser: 'rgb(52, 190, 205)',
	entitlements: 'rgb(183, 129, 211)',
	caseLogACall: 'rgb(242, 207, 91)',
	thanksLoading: 'rgb(184, 195, 206)',
	channelProgramLevels: 'rgb(14, 181, 138)',
	emailChatter: 'rgb(242, 207, 91)',
	announcement: 'rgb(98, 183, 237)',
	bot: 'rgb(84, 105, 143)',
	macros: 'rgb(71, 207, 210)',
	assetRelationship: 'rgb(250, 151, 92)',
	coaching: 'rgb(246, 117, 148)',
	search: 'rgb(98, 183, 237)',
	connectedApps: 'rgb(152, 149, 238)',
	workType: 'rgb(84, 105, 141)',
	environmentHub: 'rgb(84, 105, 141)',
	cms: 'rgb(136, 198, 81)',
	thanks: 'rgb(233, 105, 110)',
	serviceTerritoryMember: 'rgb(126, 139, 228)',
	campaignMembers: 'rgb(244, 151, 86)',
	retailBanking: 'rgb(0, 210, 190)',
	calibration: 'rgb(71, 207, 210)',
	answerPublic: 'rgb(242, 207, 91)',
	unmatched: 'rgb(98, 183, 237)',
	partners: 'rgb(14, 181, 138)',
	emailIq: 'rgb(160, 148, 237)',
	serviceCrew: 'rgb(250, 151, 92)',
	resourceCapacity: 'rgb(69, 193, 115)',
	channelPrograms: 'rgb(14, 181, 138)',
	quip: 'rgb(37, 180, 233)',
	quipSheet: 'rgb(48, 200, 90)',
	timeslot: 'rgb(250, 178, 76)',
	liveChat: 'rgb(248, 137, 96)',
	user: 'rgb(52, 190, 205)',
	client: 'rgb(0, 210, 190)',
	portal: 'rgb(174, 199, 112)',
	partnerFundRequest: 'rgb(14, 181, 138)',
	resourcePreference: 'rgb(69, 193, 115)',
	resourceAbsence: 'rgb(69, 193, 115)',
	entitlementTemplate: 'rgb(126, 139, 228)',
	entitlement: 'rgb(126, 139, 228)',
	empty: 'rgb(129, 153, 175)',
	caseEmail: 'rgb(242, 207, 91)',
	account: 'rgb(127, 141, 225)',
	wealthManagementConsole: 'rgb(0, 175, 160)',
	task2: 'rgb(75, 192, 118)',
	social: 'rgb(234, 116, 162)',
	endorsement: 'rgb(139, 154, 227)',
	folder: 'rgb(139, 154, 227)',
	serviceCrewMember: 'rgb(126, 139, 228)',
	flow: 'rgb(0, 121, 188)',
	omniSupervisor: 'rgb(138, 118, 240)',
	product: 'rgb(183, 129, 211)',
	topic: 'rgb(86, 170, 223)',
	productRequired: 'rgb(239, 110, 100)',
	process: 'rgb(0, 121, 188)',
	people: 'rgb(52, 190, 205)',
	reward: 'rgb(233, 105, 110)',
	performance: 'rgb(248, 177, 86)',
	caseComment: 'rgb(242, 207, 91)',
	campaign: 'rgb(244, 151, 86)',
	businessHours: 'rgb(125, 195, 125)',
	evernote: 'rgb(134, 200, 111)',
	serviceTerritory: 'rgb(126, 139, 228)',
	case: 'rgb(242, 207, 91)',
	record: 'rgb(125, 195, 125)',
	contractLineItem: 'rgb(110, 192, 110)',
	skillEntity: 'rgb(139, 154, 227)',
	skill: 'rgb(250, 151, 92)',
	operatingHours: 'rgb(107, 158, 226)',
	custom: 'rgb(129, 153, 175)',
	relatedList: 'rgb(89, 188, 171)',
	caseChangeStatus: 'rgb(242, 207, 91)',
	insuranceConsole: 'rgb(0, 175, 160)',
	contract: 'rgb(110, 192, 110)',
	photo: 'rgb(215, 209, 209)',
	apps: 'rgb(60, 151, 221)',
	timesheet: 'rgb(126, 139, 228)',
	drafts: 'rgb(108, 161, 233)',
	workOrderItem: 'rgb(51, 168, 220)',
	pricebook: 'rgb(183, 129, 211)',
	scanCard: 'rgb(243, 158, 88)',
	note: 'rgb(230, 212, 120)',
	opportunity: 'rgb(252, 185, 91)',
	news: 'rgb(127, 141, 225)',
	callHistory: 'rgb(242, 207, 91)',
	report: 'rgb(46, 203, 190)',
	groups: 'rgb(119, 158, 242)',
	dashboard: 'rgb(239, 110, 100)',
	genericLoading: 'rgb(184, 195, 206)',
	address: 'rgb(75, 192, 118)',
	entityMilestone: 'rgb(244, 151, 86)',
	wealthManagement: 'rgb(0, 210, 190)',
	customers: 'rgb(14, 181, 138)',
	serviceAppointment: 'rgb(126, 139, 228)',
	maintenancePlan: 'rgb(42, 115, 158)',
	dataIntegrationHub: 'rgb(42, 115, 158)',
	hierarchy: 'rgb(52, 190, 205)',
	partnerMarketingBudget: 'rgb(14, 181, 138)',
	skillRequirement: 'rgb(250, 151, 92)',
	location: 'rgb(75, 192, 118)',
	avatarLoading: 'rgb(184, 195, 206)',
	article: 'rgb(242, 207, 91)',
	logACall: 'rgb(72, 195, 204)',
	quotes: 'rgb(136, 198, 81)',
	questionFeed: 'rgb(242, 207, 91)',
	merge: 'rgb(242, 207, 91)',
	productConsumed: 'rgb(85, 188, 156)',
	canvas: 'rgb(129, 153, 175)',
	forecasts: 'rgb(107, 189, 110)',
	relationship: 'rgb(60, 151, 221)',
	serviceResource: 'rgb(126, 139, 228)',
	salesPath: 'rgb(42, 115, 158)',
	rtcPresence: 'rgb(71, 207, 210)',
	avatar: 'rgb(98, 183, 237)',
	solution: 'rgb(143, 201, 114)',
	partnerFundClaim: 'rgb(14, 181, 138)',
	individual: 'rgb(60, 151, 221)',
	customNotification: 'rgb(107, 183, 228)',
	template: 'rgb(60, 151, 221)',
	shipment: 'rgb(126, 139, 228)',
	event: 'rgb(235, 112, 146)',
	insurance: 'rgb(0, 210, 190)',
	liveChatVisitor: 'rgb(246, 137, 96)',
	survey: 'rgb(49, 159, 214)',
	link: 'rgb(122, 154, 230)',
	messagingSession: 'rgb(52, 190, 205)',
	listEmail: 'rgb(139, 174, 181)',
	document: 'rgb(186, 172, 147)',
	productTransfer: 'rgb(248, 137, 98)',
	recent: 'rgb(108, 161, 233)',
	insights: 'rgb(236, 148, 237)',
	dropbox: 'rgb(82, 174, 249)',
	file: 'rgb(186, 172, 147)',
	teamMember: 'rgb(242, 207, 91)',
	groupLoading: 'rgb(184, 195, 206)',
	lead: 'rgb(248, 137, 98)',
	email: 'rgb(149, 174, 197)',
	serviceContract: 'rgb(138, 118, 240)',
	entitlementProcess: 'rgb(126, 139, 228)',
	contactList: 'rgb(160, 148, 237)',
	channelProgramHistory: 'rgb(14, 181, 138)',
	questionBest: 'rgb(242, 207, 91)',
	knowledge: 'rgb(236, 148, 237)',
	leadInsights: 'rgb(34, 176, 230)',
	concur: 'rgb(76, 195, 199)',
	feed: 'rgb(98, 183, 237)',
	messagingConversation: 'rgb(52, 190, 205)',
	serviceReport: 'rgb(126, 139, 228)',
	call: 'rgb(242, 207, 91)',
	stage: 'rgb(255, 154, 60)',
	productRequestLineItem: 'rgb(136, 198, 81)',
	returnOrderLineItem: 'rgb(0, 150, 136)',
	quickText: 'rgb(98, 183, 229)',
	home: 'rgb(239, 126, 173)',
	sossession: 'rgb(84, 105, 141)',
	stageCollection: 'rgb(255, 154, 60)',
	productRequest: 'rgb(136, 198, 81)',
	logging: 'rgb(0, 161, 223)',
	assignedResource: 'rgb(69, 193, 115)',
	returnOrder: 'rgb(0, 150, 136)',
	poll: 'rgb(105, 155, 225)',
	household: 'rgb(0, 175, 160)',
};
